<template>
  <div class="container" v-if="loadingPageOver" :style="iosOrAndroidStyle">

    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="超级会员"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />

    <div class="mobile-page-container" :style="iosOrAndroidStyle">
      <div class="promotions" v-if="!isBaidu && !isQQMini && !isAlipayClient && !isUCClient && !isQuaReClient">
        <!-- <div class="invite free-membership-card-container" v-if="!hide">
          <div class="title theme-color">
            30天会员免费领
          </div>
          <div class="subtitle">
            扫码关注公众号，领取超级会员
          </div>
          <img src="https://files.wondercv.com/%E4%BC%9A%E5%91%98%E9%A1%B5-30%E5%A4%A9%E5%85%8D%E8%B4%B9.png">
        </div> -->
      </div>
      <div class="member-right-panel">
        <div class="member-card">
          <div class="card-title">超级会员</div>
          <div class="card-item">
            <div class="item-title">功能</div>
            <div class="item-desc" v-for="item in super_member_feature_options">
              <span class="item-text">{{ item.text }}</span>
              <span class="item-featrue">{{ item.featrue }}</span>
            </div>
          </div>
          <div class="card-item">
            <div class="item-title">服务</div>
            <div class="item-desc" v-for="item in super_member_service_options">
              <span class="item-text">{{ item }}</span>
            </div>
          </div>
          <div class="submit-btn" v-if="!isBaidu && !isQQMini">
            <span v-if="_t" @click="biuldOrder">立即升级</span>
            <span v-else @click="signInWithReturnTo('/buy/member/order')">立即升级</span>
          </div>
        </div>
      </div>
      <div class="member-desc">
        <p>会员说明：</p>
        <p v-for="e in member_desc_options" v-bind:value="e" :key='e'>
          {{ e }}
        </p>
      </div>
    </div>
    <pay-dialog :state="dialogShow" :imgSrc="imgSrc" :descriptionInfo="descriptionInfo" :dialog-type="'member'"
                @shareWx="sendWechat" @handleClose="dialogShow = false"></pay-dialog>
  </div>
</template>
<script>
  import WNavbar from "@/components/global/w-navbar";
	import memberPayDialog from '@/components/ios/member-pay-dialog'
  import payDialog from '@/components/ios/pay-dialog'
  import Cookies from "js-cookie";
	import { setupWebViewJavascriptBridge, toLogin} from '@/assets/js/utils'
	import { WxMixin, envMixin, loginMixin } from '@/assets/js/mixin/global'
  import { mapState, mapActions } from 'vuex'

  const moment = require('moment')

  export default {
      mixins: [ WxMixin, envMixin, loginMixin ],
      data () {
        return {
          _t: '',
          navTitle: '超级会员',
          userSignedIn: false,
          isBaidu: false,
          isQQMini: false,
          isAlipayClient: false, // 检测是不是支付宝
          dialogShow: false,
          imgSrc: 'https://files.wondercv.com/mobile/cvs/ios-pay-member.png',
          descriptionInfo: [
              '享受超级简历所有特权',
              'AI 简历助手 智能改简历',
              '无限使用大牛模板案例',
              '帮你大幅提升求职成功率'
          ],
          super_member_service_options: ['专享云安全加密', '7x8 小时 VIP客服答疑'],
          super_member_feature_options: [
            {
              text: '中英文简历份数',
              featrue: '15份'
            },{
              text: 'AI 智能检查次数',
              featrue: '无限'
            },{
              text: '自动翻译使用次数',
              featrue: '无限'
            },{
              text: '简历模板可用数量',
              featrue: '无限'
            },
          ],
          member_desc_options: ['1. 从购买后立刻开始生效，享有超级会员所有特权', '2. 使用期间可随时续费，有效期将直接累加', '3. 会员过期后仅可使用免费功能', '4. 可在我的订单中查看购买记录和时间', '5. 最终解释权归超级简历所有，如有疑问，请联系在线客服']
        }
      },
      mounted () {
        let _t = Cookies.get("_t");
        this._t = _t;
        this.judgeSource()
        this.loadPageData()
      },
      computed: {
        ...mapState('user', [ 'buyMemeberData' ]),
        hide () {
          return this.$route.query.hide
        }
      },
      methods: {
        ...mapActions('user'),
        leftBtnClick() {
          this.routeTo('/account/users/index')
        },
        async loadPageData () {
          // 登录带参数, 不登录不带参数
          if (this._t) {
              this.userSignedIn = true
              this.getMobileAccountUsersBuyMember({})
          } else {
              this.getMobileAccountUsersBuyMember({})
          }
        },

        async signInWithReturnTo (returnTo) {
          if (this.isWechatBrowser) {
            let { hostname } = window.location
            Cookies.set('_r_b_t', window.location.href, {
              domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
              path: '/',
              expires: moment()
                .add(30, 'd')
                .valueOf()
            })
            window.location.href = `/login-method`
          } else {
            toLogin(window.location.href)
          }
        },
        sendWechat () {
          if (this.iosOrAndroid) {
            setupWebViewJavascriptBridge(function (bridge) {
              bridge.callHandler('shareMember', {
                  title: '升级超级会员',
                  desc: '超级会员可以创建多份简历及求职信等文件。可以无限编辑、下载和复制文件，可以看到全部完整案例，并且可以无限制使用简历智能优化功能。'
              }, function responseCallback (responseData) {
              })
            })
          }
        },
        biuldOrder () {
          // 提交订单, 跳转页面 POST
          if (this.isIos) {
              this.dialogShow = true
          } else {
            this.$router.push({path:'/buy/member/order'})
          }
        },
        judgeSource () {
          let isBaidu = navigator.userAgent.toLocaleLowerCase().includes('swan-baiduboxapp')
          let isQQMini = navigator.userAgent.includes('QQ') && navigator.userAgent.toLocaleLowerCase().includes('miniprogram')
          this.isAlipayClient = navigator.userAgent.toLocaleLowerCase().includes('alipayclient')
          if (isBaidu) {
            this.isBaidu = true
          }
          if (isQQMini) {
            this.isQQMini = true
          }
        }
      },
      components: {
        WNavbar,
        payDialog,
        memberPayDialog
      }
	}
</script>

<style lang="scss" scoped>
  .container {
    min-height: calc(100vh - 44px);
    background: #f5f5f7;
    font-family: PingFangSC-Regular;
    padding-top: 44px;
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      background-color: #fff;
      width: 80vw;
      padding: 30px 60px;
      .header {
        font-size: 18px;
        color: #404040;
        margin-bottom: 10px;
      }
      .desc {
        font-size: 14px;
        color: #6da0ec;
        text-align: center;
        margin-bottom: 20px;
        line-height: 20px;
        span {
          font-size: 13px;
        }
      }
      ul {
        margin-left: 26px;
        li {
          margin-bottom: 24px;
          color: #606060;
        }
      }
      .wechat-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 40px;
        text-align: center;
        background-color: #49be63;
        border-radius: 25px;
        color: #fff;
        margin-bottom: 20px;
        font-size: 13px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
      }
      .bottom {
        font-size: 12px;
        color: #909090;
      }
    }
  }

  .theme-color {
    color: #ff4f4c !important;
  }

  .f-s-16 {
    font-size: 16px;
  }

  p {
    margin: 0 0 10px;
    -webkit-margin-before: 0 !important;
    -webkit-margin-after: 0 !important;
  }

  .button-lg {
    border-radius: 2px;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    height: 40px !important;
    line-height: 40px !important;
    text-align: center;
  }

  .mobile-page-container {
    font-weight: 100;
    font-size: 14px;
    line-height: 1.428571429;

    .promotions {
      left: 0;
      right: 0;
      padding: 8px 20px 0;
      margin-bottom: 16px;
      width: 100%;
      box-sizing: border-box;

      .invite {
        background-color: #fff;
        padding: 20px 20px 30px 20px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        width: 100%;
      }

      .free-membership-card-container {
        text-align: center;
        box-sizing: border-box;

        .title {
          font-size: 24px;
          margin-top: 6px;
          font-weight: 500;
        }

        .subtitle {
          font-size: 15px;
          margin-top: 12px;
        }

        img {
          width: 125px;
          height: 125px;
          display: block;
          margin: 22px auto 0;
          vertical-align: middle;
          border: 0;
        }
      }
    }

    .member-right-panel {
      width: 100%;
      background-color: transparent;
      height: 421px;
      padding: 0 20px;

      .member-card {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 6px;
        padding: 0 36px;
        .card-title {
          width: 100%;
          height: 70px;
          border-bottom: 1px solid #e9e9e9;
          font-size: 24px;
          font-weight: 500;
          color: #FF4F4C;
          line-height: 70px;
          text-align: center;
        }
        .card-item {
          width: 100%;
          margin-top: 24px;
          .item-title {
            font-size: 16px;
            font-weight: 500;
            color: #404040;
          }
          .item-desc {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 14px;
            &:first-child {
              margin-top: 18px;
            }
            .item-text {
              font-size: 14px;
              font-weight: 400;
              color: #606060;
              line-height: 14px;
            }
            .item-featrue {
              font-size: 14px;
              font-weight: 400;
              color: #FF4F4C;
              line-height: 14px;
            }
          }
        }
        .submit-btn {
          width: 263px;
          height: 36px;
          margin-top: 28px;
          background: #FF4F4C;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 36px;
          text-align: center;
        }
      }


    }

    .member-desc {
      width: auto;
      height: auto;
      margin: 12px 20px;
      border-radius: 8px;
      padding: 20px;
      color: #909090;
      background-color: #fff;
    }
  }
</style>
